import script from "./VouchersManualActivatePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./VouchersManualActivatePage.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__